/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum DiagnosisInactivationAliases {
  CANCEL_BUTTON = 'cancel-button',
  INACTIVATION_JUSTIFICATION_BUTTON = 'inactivation-justification-button',
  JUSTIFICATION_BUTTONS_PANEL = 'justification-buttons-panel',
  JUSTIFICATION_FIELD = 'justification-field',
  JUSTIFICATION_FORM = 'justification-form',
  JUSTIFICATION_PANEL = 'justification-panel',
  JUSTIFICATION_TEXT_AREA = 'justification-text-area',
  LAYOUT_PATIENT_EVOLUTION = 'layout-patient-evolution',
  LOADER = 'loader',
  MODAL_DIAGNOSIS_INACTIVATE = 'modal-diagnosis-inactivate',
  PANEL_BUTTONS_DOCKER = 'panel-buttons-docker',
  PANEL_LOADER = 'panel-loader',
  TEXT_AREA_PANEL = 'text-area-panel',
}
export { DiagnosisInactivationAliases };
